/* global LayoutBuilderUI */

'use es6';

import { APP_STARTED, CLOSE_HEADER_MENU, RENDER_FAILED, LBUI_READY, TRACK_APP_LIFECYCLE_TIMESTAMP, TRACK_PREVIEW_METRICS, FLOATING_ALERT_MESSAGE, RENDER_MODULE_WITH_CONTEXT, OPEN_SAVE_SECTION_MODAL, RENDER_MODULE, LOG_INTERACTION, UPLOAD_FILE, IFRAME_CLICKED, FOCUS_ON_FIELD, LOG_TINYMCE_INTERACTION, FETCH_CUSTOM_MODULES, DROP_SAVED_SECTION_ON_SECTION, FETCH_SAVED_SECTIONS, FLEX_AREA_INDEX, ADD_MODULE_SIDEBAR_LOADED, CAPTURE_PAGE_EVENT } from 'EmailEditorUI/dragDropMessageTypes';
import throttle from 'hs-lodash/throttle';
import emptyFunction from 'react-utils/emptyFunction';
function callbackIfResp(callback, errorCallback = emptyFunction) {
  return resp => {
    if (resp) {
      if (resp.error) {
        errorCallback(resp);
      } else {
        callback(resp);
      }
    }
  };
}
export function initLayoutBuilder(callback) {
  return LayoutBuilderUI.messenger.postMessage(APP_STARTED, {}, callbackIfResp(callback));
}
export function reportRenderFailed(shouldReportFatalTemplateError = false) {
  return LayoutBuilderUI.messenger.postMessage(RENDER_FAILED, {
    shouldReportFatalTemplateError
  });
}
export function capturePageEvent(message, options) {
  return LayoutBuilderUI.messenger.postMessage(CAPTURE_PAGE_EVENT, {
    message,
    options
  });
}
export function reportLBUIReady() {
  return LayoutBuilderUI.messenger.postMessage(LBUI_READY, {});
}
export function reportAddModuleSidebarLoaded() {
  return LayoutBuilderUI.messenger.postMessage(ADD_MODULE_SIDEBAR_LOADED, {});
}
export function reportFlexAreaIndex(flexAreaIndex) {
  return LayoutBuilderUI.messenger.postMessage(FLEX_AREA_INDEX, {
    flexAreaIndex
  });
}
export function trackAppLifecycleTimestamp(lifecycle) {
  return LayoutBuilderUI.messenger.postMessage(TRACK_APP_LIFECYCLE_TIMESTAMP, lifecycle);
}
export function reportPreviewMetrics(metrics, dimensions) {
  return LayoutBuilderUI.messenger.postMessage(TRACK_PREVIEW_METRICS, {
    metrics,
    dimensions
  });
}
export function floatingAlertMessage(data) {
  return LayoutBuilderUI.messenger.postMessage(FLOATING_ALERT_MESSAGE, data);
}
export function openSaveSectionModal(sectionId, offset) {
  return LayoutBuilderUI.messenger.postMessage(OPEN_SAVE_SECTION_MODAL, {
    sectionId,
    offset
  });
}
const throttledRenderModuleFunctions = {};
function renderModuleFunc(moduleParam, callbackParam, contentId, contentPatch, useCachedContent = false) {
  if (contentId && contentPatch) {
    return LayoutBuilderUI.messenger.postMessage(RENDER_MODULE_WITH_CONTEXT, {
      data: {
        widgetParams: moduleParam,
        contentId,
        contentPatch,
        useCachedContent
      },
      getParams: {
        contentId
      }
    }, callbackIfResp(callbackParam));
  }
  return LayoutBuilderUI.messenger.postMessage(RENDER_MODULE, {
    data: moduleParam
  }, callbackIfResp(callbackParam));
}
export function handleFileUpload(file, moduleId, callbackParam, errCallbackParam) {
  return LayoutBuilderUI.messenger.postMessage(UPLOAD_FILE, {
    file,
    moduleId
  }, callbackIfResp(callbackParam, errCallbackParam));
}
export function renderModule(module, ...args) {
  if (!throttledRenderModuleFunctions[module.get('id')]) {
    throttledRenderModuleFunctions[module.get('id')] = throttle(renderModuleFunc, 50);
  }
  throttledRenderModuleFunctions[module.get('id')](module, ...args);
}
export function logInteraction(interactionData) {
  return LayoutBuilderUI.messenger.postMessage(LOG_INTERACTION, {
    interactionData
  });
}
export function iframeClicked() {
  return LayoutBuilderUI.messenger.postMessage(IFRAME_CLICKED);
}
export function closeHeaderMenu() {
  return LayoutBuilderUI.messenger.postMessage(CLOSE_HEADER_MENU);
}
export function focusOnElement(element) {
  return LayoutBuilderUI.messenger.postMessage(FOCUS_ON_FIELD, {
    element
  });
}
export function logTinyMCEInteraction(action) {
  return LayoutBuilderUI.messenger.postMessage(LOG_TINYMCE_INTERACTION, {
    action
  });
}
export function fetchCustomModules() {
  return LayoutBuilderUI.messenger.postMessage(FETCH_CUSTOM_MODULES, {});
}
export function dispatchActionInParent(action) {
  return LayoutBuilderUI.messenger.dispatchAction(action);
}
export function dropSavedSectionOnSection(data) {
  return LayoutBuilderUI.messenger.postMessage(DROP_SAVED_SECTION_ON_SECTION, data);
}
export function fetchSavedSections(fetchAll, withReset, customQuery) {
  return LayoutBuilderUI.messenger.postMessage(FETCH_SAVED_SECTIONS, {
    fetchAll,
    withReset,
    customQuery
  });
}